/**
 * @generated SignedSource<<d787b7c063bef87fc2acc4abf25b266a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AboutMeFormFragment$data = {
  readonly id: string;
  readonly aboutMe: string;
  readonly currentPosition: string;
  readonly " $fragmentType": "AboutMeFormFragment";
};
export type AboutMeFormFragment$key = {
  readonly " $data"?: AboutMeFormFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AboutMeFormFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AboutMeFormFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aboutMe",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentPosition",
      "storageKey": null
    }
  ],
  "type": "Caregiver",
  "abstractKey": null
};

(node as any).hash = "2dce05efd76db8666e1bdf3f7b73061a";

export default node;
